var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24972 7.74992L8.24972 8.24992M7.74972 7.74992V8.24992M8.24972 3.08325L8.24972 3.58325M7.74972 3.08325V3.58325M8.24972 12.4166L8.24972 12.9166M7.74972 12.4166V12.9166M7.99967 8.66675C7.63148 8.66675 7.33301 8.36827 7.33301 8.00008C7.33301 7.63189 7.63148 7.33341 7.99967 7.33341C8.36786 7.33341 8.66634 7.63189 8.66634 8.00008C8.66634 8.36827 8.36786 8.66675 7.99967 8.66675ZM7.99967 4.00008C7.63148 4.00008 7.33301 3.7016 7.33301 3.33341C7.33301 2.96523 7.63148 2.66675 7.99967 2.66675C8.36786 2.66675 8.66634 2.96523 8.66634 3.33341C8.66634 3.7016 8.36786 4.00008 7.99967 4.00008ZM7.99967 13.3334C7.63148 13.3334 7.33301 13.0349 7.33301 12.6667C7.33301 12.2986 7.63148 12.0001 7.99967 12.0001C8.36786 12.0001 8.66634 12.2986 8.66634 12.6667C8.66634 13.0349 8.36786 13.3334 7.99967 13.3334Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.f0a76a8d71a86ea3ecafb5a21d584c5d.svg";
export { ForwardRef as ReactComponent };